import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EscalateTicketModal from "../../component/EscalateTicketModal";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import { useSwal } from "../../services/SweetAlert";
import api from "../../services/axios";
import CustomDropdown from "../../component/CustomDropdown";
import FaqSidebar from "../../component/TicketSidebar/FaqSidebar";
import utils from "../../utils/utils";
import CKEditorWrapper from "../../component/RichTextEditorFile";
import IconClose from "../../component/SvgIcons/IconClose";
import FileUpload from "../../component/SvgIcons/FileUpload";
import IconError from "../../component/SvgIcons/IconError";
export default function ReopenTicket() {
  const navigate = useNavigate();
  const { alert } = useSwal();
  const { ticket_no } = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [appType, setAppType] = useState([]);
  const [QueryType, setQueryType] = useState([]);
  const [Priority_Id, setpriority] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [statusData, setStatusData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    utils.saveRecentSearch("Reopen Ticket", window.location.pathname);
  }, []);

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const response = await api.post("/Ticket_Statuses");        
        setStatusData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching status data:", error);
      }
    };

    fetchStatusData();

    const fetchAppTypes = async () => {
      try {
        const res = await api.post("/Application_Types");        
        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Id,
            label: item.DisplayName,
          }));
          // setAppType(transformed);
          setAppType([
            { value: "", label: "Select Application Type", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchAppTypes();

    const fetchpriority = async () => {
      try {
        const res = await api.post("/getpriority_list");

        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Id,
            label: item.DisplayName,
            color: item.ColorCode || "#000", // Default to black if no color is provided
          }));
          // setAppType(transformed);
          setpriority([
            { value: "", label: "Select Priority  Type", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchpriority();

    const fetchQueryType = async () => {
      try {
        const res = await api.post(
          "/getAllTemplates",
          {},
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        const dataArr = Array.isArray(res.data.data) ? res.data.data : [];

        if (dataArr.length > 0) {
          const transformed = dataArr.map((item) => ({
            value: item.TemplateID?.toString() ?? "",
            label: item.Query ?? "(no query text)",
            issueDetails: item.Issue ?? "",
            remarks: item.Remarks ?? "",
          }));

          setQueryType([
            { value: "", label: "Select Query Template", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("No templates found.");
        }
      } catch (err) {
        console.error("Failed to fetch templates:", err);
      }
    };

    fetchQueryType();
  }, []);
  const filteredStatusData = statusData.filter(
    (status) =>
      status.Name !== "Open" &&
      status.Name !== "Escalated" &&
      status.Name !== "ReOpened"
  );

  useEffect(() => {
    const fetchTicketDetails = async () => {
      try {
        const res = await api.post("/list_ticket", {
          Ticket_No: ticket_no,
        });
        console.log("response", res.data.data);
        const tickets = res?.data?.data || [];
        if (tickets.length > 0) {          
          setFormData(tickets[0]);
        } else {
          alert("warning", "Ticket not found");
        }
      } catch (error) {
        console.error("Error fetching tickets:", error);
      } finally {
        setLoading(false);
      }
    };

    if (ticket_no) {
      fetchTicketDetails();
    }
  }, []);
  const getFieldError = (name, value) => {
    switch (name) {
    case "Issue_Details":
      return !value?.trim() ? "Issue Details cannot be empty." : "";
      case "Action_Remarks":
      return !value || value.trim() === ""
        ? "Remarks cannot be empty."
        : "";
      default:
        return "";
    }
  };
  const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
     const newErrors = {};
    let isValid = true;

    ["Issue_Details", "Action_Remarks"].forEach((field) => {
    const error = getFieldError(field, formData[field]);
    if (error) {
      newErrors[field] = error;
      isValid = false;
    }
  });
  setFormErrors(newErrors);
    if (!isValid) {
    alert("warning", "Please fill in all required fields correctly.");
    return;  // <- Stop submission here
  }
  setLoading(true);
 
    try {
      const payload = {
        Ticket_No: formData.Ticket_No,
        User: formData.User || localStorage.getItem("user"),
        Issue_Details: formData.Issue_Details,
        Status: formData.Status || "ReOpened",
        Phone_no: formData.Phone_no,
        Contact_Email_Id: formData.Contact_Email_Id,
        Recording_Path: formData.Recording_Path || "",
        Remarks: formData.Action_Remarks,
        Priority_Id: formData.Priority_Id,        
        Query: formData.Query,
        Tags: formData.Tags,
      };

      const { status, data } = await api.post(
        "/add_action_to_ticket",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (status === 200) {
        alert("success", "Action added and ticket updated.");
        navigate(`/view-ticket-history/${ticket_no}`);
      } else {
        alert("error", data.message || "Unexpected response");
      }
    } catch (err) {
      console.error("Submission error:", err);
      const message =
        err.response?.data?.message || err.message || "Submission failed";
      alert("error", message);
    } finally {
      setLoading(false);
    }
  };
 
  const handleChange = async (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: maybeValue }));

      if (eOrName === "Query" && maybeValue) {
        try {
          const selectedTemplate = QueryType.find(
            (template) => template.value === maybeValue
          );
          if (selectedTemplate) {
            setFormData((prev) => ({
              ...prev,
                Issue_Details: `${
                  prev.Issue_Details?.trim() || ""
                }<hr/><strong>New Issue:</strong><br/>${
                  selectedTemplate.issueDetails?.trim() || ""
                }`,
              Remarks: selectedTemplate.remarks || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching template details:", error);
        }
      }
      validateField(eOrName, maybeValue);
    } else {
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (name === "Query" && value) {
        try {
          const selectedTemplate = QueryType.find(
            (template) => template.value === value
          );
          if (selectedTemplate) {
            setFormData((prev) => ({
              ...prev,
              Issue_Details: selectedTemplate.issueDetails || "",
              Remarks: selectedTemplate.remarks || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching template details:", error);
        }
      }
      validateField(name, value);
    }
  };
  const handleEscalationSave = async (escalationData) => {
  const updatedFormData = {
    ...formData,
    ...escalationData,
  };

  setFormData(updatedFormData);
  const requiredFields = [
    { name: "Customer_Code", message: "Please select customer." },
    { name: "Contact_Person", message: "Contact Person is required." },
    { name: "Status", message: "Status is required." },
    { name: "Issue_Details", message: "Please provide issue details." },
    { name: "Action_Remarks", message: "Remarks is required." },
  ];
  const newErrors = {};
  let isValid = true;

  requiredFields.forEach(({ name, message }) => {
    if (!updatedFormData[name] || updatedFormData[name].toString().trim() === "") {
      newErrors[name] = message;
      isValid = false;
    }
  });   
  setFormErrors(newErrors);
  if (!isValid) {
    await alert("warning", "Please fill in all required fields correctly.");
    return;
  } 
   
  const payload = {
    Ticket_No: updatedFormData.Ticket_No,
    Customer_Code: updatedFormData.Customer_Code,
    Contact_Person: updatedFormData.Contact_Person,
  User: formData.User?.Code || JSON.parse(localStorage.getItem("user"))?.Code,
    Phone_no: updatedFormData.Phone_no,
    Email_Id: updatedFormData.Contact_Email_Id,
    Application_Name: updatedFormData.Application_Name,
    Issue_Details: updatedFormData.Issue_Details,
    Status: updatedFormData.Status,
    Query: updatedFormData.Query,
    Remarks: updatedFormData.Remarks,
    tags: updatedFormData.tags,
    Priority_Id: updatedFormData.Priority_Id,
    Designation: updatedFormData.Designation,
    Customer_Type: updatedFormData.Customer_Type,
    escalated_to: updatedFormData.escalated_to, 
  };

    try {
      setLoading(true);

      const formPayload = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formPayload.append(key, value);
        }
      });

      if (updatedFormData.picture) {
        formPayload.append("picture", updatedFormData.picture);
      }

      const res = await api.post("/add_action_to_ticket", formPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // const newTicketNo = res?.data?.Ticket_No;

      await alert(
        "success",
        `Ticket Escalate successfully.`
      );

      setFormData({
        Ticket_No: "",
        Customer_Code: "",
        Contact_Person: "",
        Phone_no: "",
        Email_Id: "",
        Application_Name: "",
        Issue_Details: "",
        Status: "",
        search: "",
        Customer_Type: "",
        Query: "",
        Remarks: "",
        tags: "",
        Priority_Id: 1,
        Designation: "",
        picture: null,
        escalated_to: "" 
      });
     navigate("/tickets-list");
    } catch (err) {
      setLoading(false);
      const message = err.response?.data?.message;
      await alert("warning", message || "Something went wrong.");
    } finally {
      setLoading(false);
    }


  };

    const isFormValidForEscalation = (data) => {
    return (
      !!data.Customer_Code &&
      !!data.Contact_Person &&
      // (!!data.Email_Id || !!data.Phone_no) &&
      // !!data.Status &&
      !!data.Issue_Details
    );
  };
 const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && /\.(jpg|jpeg|png|webp)$/i.test(file.name)) {
      setSelectedFile(file);
    } else {
      alert("Please select a valid image file (jpg, jpeg, png, webp).");
      e.target.value = "";
      setSelectedFile(null);
    }
  };  
  return (
    <div className="dashboard">
      <Header
        setShowSidebar={setShowSidebar}
        title
        subtitle="Re Opened Ticket"
        backbtn={`/view-ticket-history/${ticket_no}`}
        searchbar
      />

      {/* <Header title subtitle="Re Opened Ticket" backbtn/> */}
      {/* <div
        className={`center-content ${
          showSidebar ? "custom-container mr-0" : "mr-hide"
        }`}
      > */}
      <motion.div
          className={`center-content custom-container ${!showSidebar ? "hide-sidebar" : ""}`}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
        {/* <div className="center-content"> */}
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <h2 className="create-titles mb-0 d-flex align-items-center">
              <DiamondsFour /> <span> Re Opened Ticket</span>
            </h2>
            {loading ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
                className="text-center py-4"
              >
                <div
                  className="spinner-border text-primary"
                  role="status"
                ></div>
                <div>Loading ticket details...</div>
              </motion.div>
            ) : (
              // <form className="createticket myform d-flex flex-column justify-content-between" onSubmit={handleSubmit}>
              <AnimatePresence mode="wait">
                <motion.form
                  key={formData.Ticket_No} // unique key to trigger animation if needed
                  className="createticket myform d-flex flex-column justify-content-between"
                  style={{ minHeight: "100%" }}
                  onSubmit={handleSubmit}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="form-savebtns newformbutton d-flex flex-wrap flex-xxl-row align-items-center">
                    <div className="status-buttons">
                      <EscalateTicketModal onSave={handleEscalationSave} disabled={!isFormValidForEscalation(formData)} />
                      {filteredStatusData.map((status) => (
                        <button
                          key={status.Id}
                          type="button"
                          className={`btn statusbtnform ${
                            formData.Status === status.Name ? "active" : ""
                          }`}
                          // style={{ backgroundColor: status.ColorCode }}
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              Status: status.Name,
                            }))
                          }
                        >
                          {status.DisplayName}
                        </button>
                      ))}
                    </div>

                    <div className="d-flex gap-3">
                      <Link
                        to={`/view-ticket-history/${ticket_no}`}
                        className="btn cancelbtn"
                      >
                        Close
                      </Link>
                      <button
                        type="submit"
                        className="btn btngradiant"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>

                  <div className="create-form d-flex flex-column">
                    <div className="form-row formresponsive">
                      <div className="form-group">
                        <label>Ticket Number</label>
                        <input
                          type="name"
                          name="Ticket_No"
                          className="form-control"
                          placeholder="Enter Ticket Number"
                          value={formData.Ticket_No}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Customer Name</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="customer name"
                          value={formData.Customer_Name}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Customer Type</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="customer type"
                          value={formData.Customer_Type}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Designation</label>
                        <input
                          type="text"
                          name="Designation"
                          className="form-control"
                          placeholder="Enter Designation"
                          // value={formData.Phone_no}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Contact Person</label>
                        <input
                          type="name"
                          name="Contact_Person"
                          className="form-control"
                          placeholder="Enter Name"
                          value={formData.Contact_Person}
                          onChange={handleChange}
                        />
                      </div>
                       <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name="Contact_Email_Id"
                          className="form-control"
                          placeholder="Enter email address"
                          value={formData.Contact_Email_Id}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Phone Number</label>
                        <input
                          type="phonenumber"
                          name="Phone_no"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          value={formData.Phone_no}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Application</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Application"
                          value={
                            appType.find(
                              (item) =>
                                item.value.toString() ===
                                formData.Application_Name?.toString()
                            )?.label || ""
                          }
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Priority</label>
                        <CustomDropdown
                          options={Priority_Id}
                          placeholder="Select Priority Type"
                          name="Priority_Id"
                          value={formData.Priority_Id}
                          onChange={(val) => handleChange("Priority_Id", val)}
                        />
                      </div>
                    </div>
                     <div className="form-row formresponsive">
                      <div className="form-group">
                          <label>Query</label>
                          <input
                            type="text"
                            name="Query"
                            className="form-control"
                            readOnly
                            value={
                              QueryType.find(
                                (item) =>
                                  item.value.toString() ===
                                  formData.Query?.toString()
                              )?.label || ""
                            }
                          />
                        </div>
                        <div className="form-group">
                        <label>Tags</label>
                        <input
                          type="text"
                          name="Tags"
                          className="form-control"
                          placeholder="Enter tags"
                          value={formData.tags}
                          onChange={handleChange}
                           readOnly
                        />
                      </div>
                      </div>

                     <div className={`form-group texteditor d-block ${formErrors.Issue_Details ? "fieldrequire" : ""}`}>  
                      <label>Issue</label>
                       <CKEditorWrapper
                          value={formData.Issue_Details}
                          onChange={(html) => handleChange("Issue_Details", html)}
                        />
                       <small className="hide"><IconError/></small>
                    </div>

                    <div className={`form-group texteditor d-block ${formErrors.Action_Remarks ? "fieldrequire" : ""}`}>  
                        <label>Remark</label>
                        {/* <input
                          type="text"
                          name="Action_Remarks"
                          className="form-control"
                          placeholder="Enter remarks"
                          value={formData.Action_Remarks}
                          onChange={handleChange}
                        /> */}
                        <CKEditorWrapper
                        value={formData.Action_Remarks}
                        onChange={(html) => handleChange("Action_Remarks", html)}
                      />
                      <small className="hide"><IconError/></small>
                      </div>

                    {/* <div className="custom-file position-relative text-center d-flex gap-3 flex-row align-items-center">
                      <div className={`pictureupload ${selectedFile ? "uploaded" : ""}`}>
                      <input
                        type="file"
                        name="picture"
                        accept=".jpg, .jpeg, .png, .webp"
                        className="custom-file-input position-absolute visually-hidden z-index-1"
                        id="inputGroupFile01"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />
                      <label
                        className="custom-file-label d-flex align-items-center justify-content-center"
                        htmlFor="inputGroupFile01"
                      >
                        <FileUpload/> Upload Picture
                      </label>
                    </div>

                    <AnimatePresence>
                      {selectedFile && (
                        <motion.div
                          className="selected-file d-flex align-items-center justify-content-center gap-2"
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          transition={{ duration: 0.3 }}
                        >
                          <p className="mb-0">
                            {selectedFile.name.length > 25
                              ? `${selectedFile.name.slice(0, 25)}...`
                              : selectedFile.name}
                          </p>
                          <button
                            type="button"
                            className="btn p-0"
                            onClick={() => {
                              setSelectedFile(null);
                              fileInputRef.current.value = "";
                            }}
                          >
                            <IconClose />
                          </button>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div> */}
                  </div>
                </motion.form>
              </AnimatePresence>
            )}
          </div>
          <div className="customer-rightside">
            <AnimatePresence>
                <motion.div
                  key="faqSidebar"
                  className="faqsidebar"
                  initial={{ x: 300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: 300, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <FaqSidebar customerCode={formData.Customer_Code} />
                </motion.div>             
            </AnimatePresence>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
